// src/components/pages/AppHome.jsx
import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaCircle } from "react-icons/fa";

import ImageCarousel from "../components/pages/imageCarousel.js";
import HomePage from "./pages/homepage.js";
import FooterHomeUno from "../layouts/footerHomeUno";
import imgLogIn from "../assets/images/logocolegio.png";

function AppHome() {
  return (
    <div className="d-flex flex-column align-items-center">
      {/* Carrusel principal */}
      <ImageCarousel className="my-5" />
      <hr className="featurette-divider" />

      {/* Presentación con imagen y mensaje */}
      <Container>
        <Row className="justify-content-center align-items-center text-center texto-animado">
          <Col xs={12} md={4} className="mb-4 mb-md-0 d-flex justify-content-center texto-animado imglogin">
            <Image src={imgLogIn} alt="Login" fluid id="img-fluid-css" />
          </Col>

          <Col xs={12} md={6} data-aos="zoom-in" className="mt-0 pt-0">
            <h2 className="fw-bold display-5">
              <span className="text-inicio-home">¡Bienvenidos al</span><br />
              <span className="text-home">Colegio Santo Tomás</span>!
            </h2>
            <p className="lead opacity-75">
              Formamos personas para una sociedad más justa y humana.
              Fomentamos el pensamiento crítico, la creatividad y el respeto por la diversidad.
            </p>
            <hr className="my-4 border-top opacity-50 w-75 mx-auto" />
            <div className="mt-4">
            <Link
              to="/admision"
              className="btn btn-success btn-lg rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 text-white"
            >
              <FaCircle />
              ADMISIONES
            </Link>
          </div>
          </Col>
        </Row>
      </Container>

      <hr className="my-5 border-top opacity-50 w-75 mx-auto" />

      {/* Contenido extendido y footer */}
      <HomePage />
      <hr className="my-5 border-top opacity-50 w-75 mx-auto" />
      <FooterHomeUno />
    </div>
  );
}

export default AppHome;
